import { routeCreate } from "./route-create";

export const routePage = {
    ...routeCreate,
    account: 'account',
    adminActivity: 'admin-activity',
    adminClaim: 'admin-claim',
    adminClaimAction: 'admin-claimAction',
    adminCreditType: 'admin-creditType',
    adminDomainUser: 'admin-domainUser',
    adminFunction: 'admin-function',
    adminPageComponent: 'admin-pageComponent',
    adminPanel: 'admin-panel',
    adminRole: 'role',
    category: 'category',
    chat: 'chat',
    confirm: 'confirm',
    contact: 'contact',
    contactType: 'contactType',
    domain: 'domain',
    domainUser: 'domainUser',
    emailChange: 'email-change',
    function: 'function',
    functionMember: 'functionMember',
    home: 'home',
    image: 'image',
    login: 'login',
    message: 'message',
    notice: 'notice',
    observationType: 'observationType',
    taskType: 'taskType',
    project: 'project',
    projectFunction: 'projectFunction',
    projectFunctionMember: 'projectFunctionMember',
    projectMember: 'projectMember',
    page: 'page',
    password: 'password',
    passwordChange: 'password-change',
    recover: 'recover',
    register: 'register',
    settings: 'settings',
    signup: 'signup',
    task: 'task',
    theme: 'theme',
    user: 'user',
} as const;

export type TRoutePage = (typeof routePage)[keyof typeof routePage];
